import { Card, InputGroup } from "@blueprintjs/core";
import React, { useState } from "react";

import { MultiSelectItem } from "../../../../components/multi-select";
import { PlayCount } from "../../../../components/playCount/play-count";
import { CustomTeamSortValues, useGetCustomTeams } from "../../../../hooks/use-get-custom-teams";
import teamStyles from ".././teams.tab.module.scss";
import { LoadingConferenceTeams } from "../loading-teams";
import { CustomTeamItem } from "./custom-team-item";
import styles from "./custom-team.module.scss";

export interface CustomTeamsProps {
  handleClickPlayCount: (item: MultiSelectItem) => void;
}

export const CustomTeams = ({ handleClickPlayCount }: CustomTeamsProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sort, setSort] = useState<{ sortValue: CustomTeamSortValues; sortDirection: string }>({
    sortValue: CustomTeamSortValues.noOfPlays,
    sortDirection: "desc",
  });

  const { customTeams, loading } = useGetCustomTeams({ searchTerm, sort });

  if (loading)
    return (
      <Card>
        <LoadingConferenceTeams />
      </Card>
    );

  const handleSort = (sortValue: CustomTeamSortValues) => {
    if (sort.sortValue === sortValue) {
      setSort({ sortValue, sortDirection: sort.sortDirection === "asc" ? "desc" : "asc" });
    } else {
      setSort({ sortValue, sortDirection: "asc" });
    }
  };

  return (
    <Card className={teamStyles.customTeamsCard}>
      <div className={styles.searchContainer}>
        <InputGroup
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          large={true}
          placeholder="Search"
          leftIcon="search"
          className={styles.search}
          rightElement={searchTerm ? <PlayCount playCount={customTeams.length} /> : <></>}
        />
      </div>
      <div className={styles.customTeamHeader}>
        <div className={styles.title} onClick={() => handleSort(CustomTeamSortValues.name)}>
          Custom Teams
        </div>
        <div className={styles.playsNumberHeader} onClick={() => handleSort(CustomTeamSortValues.noOfPlays)}>
          # of Plays
        </div>
      </div>
      <div>
        {customTeams.map((team) => {
          return (
            <CustomTeamItem
              key={team.id}
              handleTeamClick={() => handleClickPlayCount({ id: team.id, label: team.name })}
              playCount={team.noOfPlays}
              team={team}
            />
          );
        })}
      </div>
    </Card>
  );
};
